// src/stores/searchStore.js
import create from "zustand";

export const useSearchStore = create((set) => ({
    searchValue: "", // Current search query
    isSearch: false, // Whether a search is triggered

    setSearchValue: (value) => set({ searchValue: value }), // Update search value
    setIsSearch: (value) => set({ isSearch: value }),       // Trigger/reset search
}));